import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'
import cannotBeTreatedValidator from '../set-and-shop-scan/cannot-be-treated-validator'
import { selectProcessContext } from '../../../state/instance-detail/selector'


export default createUIDefinition({
    taskName: taskName.VALIDATE_PRETREATMENT,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },
        {
            component: processUI.PRE_TREATMENT_REASON_WIDGET_CONTAINER,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: cannotBeTreatedValidator,
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/in-shop-scan/validate-pretreatment.js